import clsx from 'clsx';
import dynamic from 'next/dynamic';
import React, { useState } from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import { useStyles } from './styles';
import { useRouter } from 'next/router';

const DynamicAcademicContent = dynamic(() => import('../AcademicContent'));
const DynamicPharmasContent = dynamic(() => import('../PharmasContent'));
const DynamicMedicalContent = dynamic(() => import('../MedicalContent'));

export default function MainContent() {
  const [stateContent, setStateContent] = useState(1);
  const classes = useStyles();
  const router = useRouter();

  return (
    <>
      <Box bgcolor="#EEEEEE">
        <Container>
          <Box py={8}>
            <Typography variant="h4" component="p" align="center">
              <b>
                {stateContent === 1 && 'Solutions for Academic Institutions'}
                {stateContent === 2 && 'Solutions for Pharma companies & Biotechs'}
                {stateContent === 3 && 'Solutions for Scientific societies'}
              </b>
            </Typography>

            <Typography variant="h6" component="p" align="center">
              {stateContent === 1 && 'Inspire new scientific outcomes across your institution'}
              {stateContent === 2 &&
                'Produce professional designs for an accurate scientific communication'}
              {stateContent === 3 && "Incorporate Mind the Graph to your associates' benefits list"}
            </Typography>
          </Box>

          <Box display="flex" justifyContent="center" pb={2}>
            <Button
              className={clsx(classes.buttonStateContent, {
                [classes.buttonStateContentSelected]: stateContent === 1,
              })}
              disableRipple
              onClick={() => {
                setStateContent(1);
                router.push('#academic');
              }}
            >
              Academic Institutions
            </Button>

            <Box mx={10}>
              <Button
                className={clsx(classes.buttonStateContent, {
                  [classes.buttonStateContentSelected]: stateContent === 2,
                })}
                disableRipple
                onClick={() => {
                  setStateContent(2);
                  router.push('#pharma');
                }}
              >
                Pharmas and Biotechs
              </Button>
            </Box>

            <Button
              className={clsx(classes.buttonStateContent, {
                [classes.buttonStateContentSelected]: stateContent === 3,
              })}
              disableRipple
              onClick={() => {
                setStateContent(3);
                router.push('#societies');
              }}
            >
              Scientific societies
            </Button>
          </Box>
        </Container>
      </Box>

      <Box
        className={clsx(classes.contentTransition, {
          [classes.contentHidden]: stateContent !== 1,
        })}
      >
        <DynamicAcademicContent />
      </Box>

      <Box
        className={clsx(classes.contentTransition, {
          [classes.contentHidden]: stateContent !== 2,
        })}
      >
        <DynamicPharmasContent />
      </Box>

      <Box
        className={clsx(classes.contentTransition, {
          [classes.contentHidden]: stateContent !== 3,
        })}
      >
        <DynamicMedicalContent />
      </Box>
    </>
  );
}
